/**
 * 내정보 / 비밀번호 변경
 */
import React, { Component } from 'react';
import fn_set_footer from './StdtMenuCmp';
import $ from 'jquery';
import { udfAutoLogin, url, udfInlineLoading, udfNoneLoading, stdtInfo, AlertModal, udfLogOut, openAlert } from '../../common/common';
import loader from '../../imgs/ajax-loader.gif';
import { Navbar, Form, Button, Container, Badge } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowCircleLeft, faUserGraduate, faPhone } from '@fortawesome/free-solid-svg-icons';

class MyInfoCmp extends Component {
  constructor(props) {
    super(props);

    this.state = {

      // bootstrap Alert 변수
      alertShow: false,
      alertClickNo: null,
      alertClickYes: null,
      alertClickOk: null,
      alertMessage: null,

      isLoggedIn: null,
      validated: false,
      authEmailValidated: false,
      stdtInfo: null,

      submitTime: null,

    };
  }

  componentDidMount = () => {
    // 자동 로그인 체크
    udfAutoLogin(this).then((data) => {
      if (data !== null && data.userSe === 'STDT') {
        this.setState({ stdtInfo: data });
      } else if (data !== null && data.userSe === 'USR') {
        this.props.history.push('/menuList');
      } else {
        this.props.history.push('/');
      }
    });

    // 로그아웃 버튼 바인딩
    document.getElementById("logoutBtn").addEventListener('click', () => { udfLogOut(this) });
    // 뒤로 이동 버튼 바인딩
    $('.goBackBtn').on('click', () => {
      if (this.props.history !== null && typeof (this.props.history) !== undefined) this.props.history.go(-1);
    });
  }

  fn_userPwdCheck(inputId) {
    var str = $('#' + inputId).val();

    if (str.length < 6) {
      openAlert(this, '비밀번호는 문자, 숫자, 특수문자의 조합으로 6자리 이상 입력해 주세요.');
      return false;
    }

    if (!str
      .match(/([a-zA-Z0-9].*[!,@,#,$,%,^,&,*,?,_,~])|([!,@,#,$,%,^,&,*,?,_,~].*[a-zA-Z0-9])/)) {
      openAlert(this, '비밀번호는 문자, 숫자, 특수문자의 조합으로 6자리 이상 입력해 주세요.');
      return false;
    }

    var SamePass_0 = 0; // 동일문자 카운트
    var SamePass_1 = 0; // 연속성(+) 카운드
    var SamePass_2 = 0; // 연속성(-) 카운드

    var chr_pass_0;
    var chr_pass_1;

    for (var i = 0; i < str.length; i++) {
      chr_pass_0 = str.charAt(i);
      chr_pass_1 = str.charAt(i + 1);

      // 동일문자 카운트
      if (chr_pass_0 === chr_pass_1) {
        SamePass_0 = SamePass_0 + 1
      } else
        SamePass_0 = SamePass_0 < 2 ? 0 : SamePass_0;

      // 연속성(+) 카운드
      if (chr_pass_0.charCodeAt(0) - chr_pass_1.charCodeAt(0) === 1) {
        SamePass_1 = SamePass_1 + 1
      } else
        SamePass_1 = SamePass_1 < 2 ? 0 : SamePass_1;

      // 연속성(-) 카운드
      if (chr_pass_0.charCodeAt(0) - chr_pass_1.charCodeAt(0) === -1) {
        SamePass_2 = SamePass_2 + 1
      } else
        SamePass_2 = SamePass_2 < 2 ? 0 : SamePass_2;
    }

    if (SamePass_0 >= 2) {
      openAlert(this, "비밀번호는 동일문자를 3번 이상(111, aaa, !!! 등) 사용할 수 없습니다.");
      return false;
    }

    if (SamePass_1 >= 2 || SamePass_2 >= 2) {
      openAlert(this, "비밀번호는 연속된 문자열(123 또는 321, abc, cba 등)을 3자 이상 사용할 수 없습니다.");
      return false;
    }
    return true;
  }

  handleSubmit(event) {
    event.preventDefault();
    event.stopPropagation();

    const form = event.currentTarget;
    const that = this;
    if (form.checkValidity()) {

      if (this.fn_userPwdCheck('newPassword')) {
        if ($('#newPassword').val() !== $('#newPassword2').val()) {
          openAlert(this, '변경 비밀번호와 비밀번호 확인이 틀립니다.');
          $('#newPassword2').focus();
          return;
        }
      } else return false;

      udfInlineLoading();

      $.ajax({
        url: url + '/sli/cmm/updatePwd.do',
        type: 'GET',
        dataType: 'jsonp',
        data: {
          oldPassword: $('#oldPassword').val()
          , newPassword: $('#newPassword').val()
          , newPassword2: $('#newPassword2').val()
          , isMobile: 'Y'
        },
        success: function (data) {
          udfNoneLoading();

          if (!data.success)
            that.componentDidMount();
          else {
            if (data.login === "0") {
              that.setState({
                isLoggedIn: false,
              });
            } else {
              if (data.resultMsg !== '') openAlert(that, data.resultMsg);
            }
          }
        },
        error: function (jqXHR, status, error) {
          udfNoneLoading();
          that.componentDidMount();
        }
      });
    }

    this.setState({ validated: true });
  }

  authEmailHandleSubmit(event) {
    event.preventDefault();
    event.stopPropagation();

    const form = event.currentTarget;
    const that = this;

    if (this.state.submitTime && Math.floor(new Date() / 1000) - this.state.submitTime < 60 * 5) {
      openAlert(that, "이메일 재발송은 최초 요청 5분 경과 후 가능합니다.\n\n발송된 인증 메일을 확인해 주시기 바랍니다. (스팸함도 확인해 주세요)\n\n등록결과는 재로그인 하면 확인 가능합니다.");
      return;
    }

    if (form.checkValidity()) {

      /* eslint-disable no-useless-escape */
      let regex = new RegExp('[a-z0-9]+@[a-z0-9]+\.[a-z]{2,3}');

      if (!regex.test($("#AUTH_EMAIL").val())) {
        openAlert(that, "이메일 주소를 다시 입력해 주세요.\n(예: test@domain.com)");
        $("#AUTH_EMAIL").focus();
        return;
      }

      udfInlineLoading();

      var postData = {
        isMobile: 'Y',
        AUTH_EMAIL: $("#AUTH_EMAIL").val(),
        PASSWORD: $("#authPassword").val(),
        "egovframework.double.submit.preventer.parameter.name": this.state.stdtInfo.partKey,
      };

      if (this.state.stdtInfo && this.state.stdtInfo.AUTH_CFM_DATE === null) {
        $.ajax({
          type: "POST",
          dataType: "jsonp",
          url: url + "/slp/stdt/updateAuthEmail.do",
          data: postData,
          success: function (data) {
            udfNoneLoading();
            if (data.resultCd === "OK") {
              openAlert(that, "이메일 인증 메일이 발송되었습니다.\n\n발송된 인증 메일을 통해 반드시 인증 확인해 주시기 바랍니다. (10분이내)");
              that.setState({
                stdtInfo: {
                  ...that.state.stdtInfo,
                  partKey: data.partKey,
                },
                submitTime: Math.floor(new Date() / 1000),
              });
            } else if (data.resultCd === "PASSWORD-ERR") {
              openAlert(that, "비밀번호가 틀립니다.");
              that.setState({
                stdtInfo: {
                  ...that.state.stdtInfo,
                  partKey: data.partKey,
                }
              });
            } else {
              openAlert(that, "처리 실패!\n\n이미 등록된 이메일입니다.");
              that.setState({
                stdtInfo: {
                  ...that.state.stdtInfo,
                  partKey: data.partKey,
                }
              });
            }
          },
          error: function () {
            udfNoneLoading();
            openAlert(that, "처리 실패!");
          }
        });
      } else {
        $.ajax({
          type: "POST",
          dataType: "jsonp",
          url: url + "/slp/stdt/updateAuthEmailCancel.do",
          data: postData,
          success: function (data) {
            udfNoneLoading();
            if (data.resultCd === "OK") {
              openAlert(that, "이메일 인증 등록이 취소되었습니다.");
              that.setState({
                stdtInfo: {
                  ...that.state.stdtInfo,
                  AUTH_CFM_DATE: null,
                  partKey: data.partKey,
                }
              });
            } else if (data.resultCd === "PASSWORD-ERR") {
              openAlert(that, "비밀번호가 틀립니다.");
              that.setState({
                stdtInfo: {
                  ...that.state.stdtInfo,
                  partKey: data.partKey,
                }
              });
            } else {
              openAlert(that, "처리 실패!");
              that.setState({
                stdtInfo: {
                  ...that.state.stdtInfo,
                  partKey: data.partKey,
                }
              });
            }
          },
          error: function () {
            udfNoneLoading();
            openAlert(that, "처리 실패!");
          }
        });
      }
    }

    this.setState({ authEmailValidated: true });
  }

  render() {
    return (
      <>
        <AlertModal
          show={this.state.alertShow}
          onHide={this.alertClose}
          Title="스쿨라이프"
          Message={this.state.alertMessage}
          onClickOk={this.state.alertClickOk}
          onClickNo={this.state.alertClickNo}
          onClickYes={this.state.alertClickYes}
        />

        {/* loading image */}
        <div className="wrap-loading d-none">
          <img src={loader} alt="로딩 이미지" />
        </div>

        {/* header */}
        <Navbar fixed="top" className="title">
          <div className="goBackBtn"><div style={{ color: '#fff' }}><FontAwesomeIcon icon={faArrowCircleLeft} className="btn-home" /></div></div>
          내정보 / 비밀번호 변경
        </Navbar>

        {/* 학생 정보 */}
        <Container>
          <div className='row' style={{ marginTop: '4.4rem' }}>
            <div className="col-3 text-right" style={{ fontSize: '3rem' }}><FontAwesomeIcon icon={faUserGraduate} style={{ paddingRight: '5px' }} /></div>
            <div className="col pt-2">
              <ul className="pl-1">
                <li className={stdtInfo.HAKGWA === '' ? 'hidden' : ''}>{stdtInfo.HAKGWA}</li>
                <li>{stdtInfo.GRADE}학년 {stdtInfo.BAN}반 {stdtInfo.BUN}번 {stdtInfo.STD_NM}</li>
                {stdtInfo.HP_STD === "" ? null : <li><Badge variant='secondary' style={{ padding: '.3rem' }}><FontAwesomeIcon icon={faPhone} /> 학생</Badge> {stdtInfo.HP_STD}</li>}
                {stdtInfo.HP_PRT === "" ? null : <li><Badge variant='secondary' style={{ padding: '.3rem' }}><FontAwesomeIcon icon={faPhone} /> 학부모</Badge> {stdtInfo.HP_PRT}</li>}
                {stdtInfo.HP_PRT2 === "" ? null : <li><Badge variant='secondary' style={{ padding: '.3rem' }}><FontAwesomeIcon icon={faPhone} /> 학부모</Badge> {stdtInfo.HP_PRT2}</li>}
              </ul>
            </div>
          </div>

          <Form
            noValidate
            validated={this.state.validated}
            onSubmit={e => this.handleSubmit(e)}
          >
            <div className="row justify-content-md-center">
              <Form.Group controlId='oldPassword' className='has-feedback col-md-6'>
                <Form.Control type='password' placeholder='현재 비밀번호' aria-describedby='oldPassword' required title='현재 비밀번호' />
                <Form.Control.Feedback type='invalid'>현재 비밀번호를 입력해주세요.</Form.Control.Feedback>
              </Form.Group>
            </div>
            <div className="row justify-content-md-center">
              <Form.Group controlId='newPassword' className='has-feedback col-md-6'>
                <Form.Control type='password' placeholder='변경 비밀번호' aria-describedby='newPassword' required title='변경 비밀번호' />
                <Form.Control.Feedback type='invalid'>변경 비밀번호를 입력해주세요.</Form.Control.Feedback>
              </Form.Group>
            </div>
            <div className="row justify-content-md-center">
              <Form.Group controlId='newPassword2' className='has-feedback col-md-6'>
                <Form.Control type='password' placeholder='비밀번호 확인' aria-describedby='newPassword2' required title='비밀번호 확인' />
                <Form.Control.Feedback type='invalid'>비밀번호 확인를 입력해주세요.</Form.Control.Feedback>
              </Form.Group>
            </div>
            <div className="row justify-content-md-center">
              <div className="col-md-6">
                <Button type='submit' className='btn btn-height btn-school-life col'>비밀번호 변경</Button>
              </div>
            </div>
          </Form>

          <Form
            noValidate
            validated={this.state.authEmailValidated}
            onSubmit={e => this.authEmailHandleSubmit(e)}
            className="mt-5 mb-5 pb-5"
          >
            <div className="row justify-content-md-center">
              <h4 className="col-md-6">이메일 인증 등록</h4>
            </div>
            <div className="row justify-content-md-center">
              <Form.Group controlId='AUTH_EMAIL' className='has-feedback col-md-6'>
                <Form.Control
                  type='email'
                  placeholder='이메일 주소'
                  aria-describedby='AUTH_EMAIL'
                  required
                  title='이메일 주소'
                  defaultValue={this.state.stdtInfo ? this.state.stdtInfo.AUTH_EMAIL : ''}
                  readOnly={!this.state.stdtInfo || this.state.stdtInfo.AUTH_CFM_DATE !== null}
                />
                <Form.Control.Feedback type='invalid'>이메일 주소를 입력해주세요.</Form.Control.Feedback>
              </Form.Group>
            </div>
            <div className="row justify-content-md-center">
              <Form.Group controlId='authPassword' className='has-feedback col-md-6'>
                <Form.Control type='password' placeholder='스쿨라이프 접속 비밀번호' aria-describedby='authPassword' required title='스쿨라이프 접속 비밀번호' />
                <Form.Control.Feedback type='invalid'>스쿨라이프 접속 비밀번호를 입력해주세요.</Form.Control.Feedback>
              </Form.Group>
            </div>
            <div className="row justify-content-md-center">
              <p className="col-md-6">
                이메일 인증을 사용하면 비밀번호를 분실하거나 도난당한 경우에도 계정을 더 안전하게 보호 할 수 있습니다.
                수집된 이메일 정보는 다음과 같이 관리됩니다.
              </p>
            </div>
            <div className="row justify-content-md-center">
              <ul className="pl-5 col-md-6">
                <li>수집목적 : 이메일 인증, 아이디 확인, 비밀번호 초기화</li>
                <li>수집정보 : 이메일 주소</li>
                <li>보유기간 : 수집일~회원탈퇴 (학년올림 및 정보삭제(전출 등)로 인한 계정 영구 삭제)</li>
              </ul>
            </div>
            <div className="row justify-content-md-center">
              <ol className="pl-5 col-md-6">
                <li className='text-danger'>발송된 메일을 통해 반드시 인증 확인해 주시기 바랍니다. (10분이내)</li>
                <li>메일 도착 확인이 되지 않은 경우에는 스펨함 확인을 해 주시기 바랍니다.</li>
                <li>이메일 수정은 취소 처리 후 재 등록해 주세요.</li>
                <li>내정보 메뉴를 통해 언제든지 수정 및 취소가 가능합니다.</li>
              </ol>
            </div>
            <div className="row justify-content-md-center">
              <div className="col-md-6">
                <Button
                  type='submit'
                  className='btn btn-height btn-school-life col'
                  hidden={!this.state.stdtInfo || this.state.stdtInfo.AUTH_CFM_DATE !== null}
                >
                  수집동의 및 이메일 인증 등록
                </Button>
                <Button
                  type='submit'
                  className='btn btn-height btn-danger col'
                  hidden={!this.state.stdtInfo || this.state.stdtInfo.AUTH_CFM_DATE === null}
                >
                  이메일 인증 등록 취소
                </Button>
              </div>
            </div>
            <br />
            <br />
            <br />
            <br />
          </Form>
        </Container>

        {fn_set_footer('')}
      </>
    );
  }
}

export default MyInfoCmp;